import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdFilterComponent } from './hd-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdButtonModule } from '../hd-button/hd-button.module';
import { HdFormModule } from '../hd-form/hd-form.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    HdButtonModule,
    HdFormModule
  ],
  declarations: [HdFilterComponent],
  exports: [HdFilterComponent]
})
export class HdFilterModule { }
